/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * CronSchedule allow scheduling the recurring run with unix-like cron.
 * @export
 * @interface V2beta1CronSchedule
 */
export interface V2beta1CronSchedule {
  /**
   * The start time of the cron job.
   * @type {Date}
   * @memberof V2beta1CronSchedule
   */
  start_time?: Date;
  /**
   * The end time of the cron job.
   * @type {Date}
   * @memberof V2beta1CronSchedule
   */
  end_time?: Date;
  /**
   *
   * @type {string}
   * @memberof V2beta1CronSchedule
   */
  cron?: string;
}

/**
 * Check if a given object implements the V2beta1CronSchedule interface.
 */
export function instanceOfV2beta1CronSchedule(value: object): value is V2beta1CronSchedule {
  return true;
}

export function V2beta1CronScheduleFromJSON(json: any): V2beta1CronSchedule {
  return V2beta1CronScheduleFromJSONTyped(json, false);
}

export function V2beta1CronScheduleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1CronSchedule {
  if (json == null) {
    return json;
  }
  return {
    start_time: json['start_time'] == null ? undefined : new Date(json['start_time']),
    end_time: json['end_time'] == null ? undefined : new Date(json['end_time']),
    cron: json['cron'] == null ? undefined : json['cron'],
  };
}

export function V2beta1CronScheduleToJSON(json: any): V2beta1CronSchedule {
  return V2beta1CronScheduleToJSONTyped(json, false);
}

export function V2beta1CronScheduleToJSONTyped(
  value?: V2beta1CronSchedule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time:
      value['start_time'] == null ? value['start_time'] : value['start_time'].toISOString(),
    end_time: value['end_time'] == null ? value['end_time'] : value['end_time'].toISOString(),
    cron: value['cron'],
  };
}
